module.exports = __webpack_public_path__ + "img/m_tongzhi.796324e7.png";